import { TutorialRoute } from '@/features/tutorial/navigation/tutorialRoute';
import { TourPreviewScreen } from '@/features/tutorial/screens/TourPreviewScreen';
import { AppStack } from '@/navigation/stacks/appStack';

/**
 * DEV ONLY: exposes /tour-preview on the unauthenticated stack so the start
 * card and the tour can be reviewed without a login. Empty in release builds.
 */
export const useTourPreviewRouting = () => ({
  tourPreviewScreens: __DEV__
    ? [
        <AppStack.Screen
          key={TutorialRoute.TourPreview}
          name={TutorialRoute.TourPreview}
          component={TourPreviewScreen}
          options={{ headerShown: false }}
        />
      ]
    : []
});
